import React from 'react'
import ClickableCards from '../../../components/Cards/Dashboard/ClickableCards';
import DotsSpinner from '../../../components/Loader/DotsSpinner/DotsSpinner';
import { IOverAllTeacher } from '../../../types';
type Props = {
    stats: IOverAllTeacher;
    isLoading: boolean;
    district: string;
    block?: string;
    week_no?: number;
    handleModalCLick ? : (e)=> void
  };
export default function TeacherTopTen({stats, isLoading, district, block, week_no ,handleModalCLick} :Props ) {

  return (
       <div className="my-2 ml-1">
          <div className="bg-primary  py-1 rounded flex-centered mt-5 ">
            {/* <h3 className="text-white m-0">Teacher Usage</h3> */}
            {/* <div className="bg-light opacity-50  rounded text-whit flex-centered px-1 py-3"> */}
            <span className="title text-white m-0">Top 10 Teachers</span>
          </div>
      {isLoading ? (
        <DotsSpinner />
      ) : (
        <>
          <div
            className="d-flex  gap-5 pt-4"
            style={{ gap: "4px" }}
          >
             <ClickableCards
               title={"Total App Usage ( in Min.)"}
               onClick={() => {
                 stats
                   ? 
                    handleModalCLick({for:"teacher",type:"total_pall_usage_in_min_teacher"})
                   : console.log("Data not available");
               }}
               />
             <ClickableCards
               title={"Total Homework / Assignments"}
               onClick={() => {
                 stats
                   ? 
                    handleModalCLick({for:"teacher",type:"total_assessments_by_teacher"})
                   : console.log("Data not available");
               }}
               />
             {/* <ClickableCards
               title={"Total Time Spent on Student Monitoring (in mins)"}
               onClick={() => {
                 stats
                   ? 
                    handleModalCLick({for:"teacher",type:"timeSpentOnStudentMonitoring"})
                   : console.log("Data not available");
               }}
               /> */}
           </div>
        </>)
      }
    </div>
  )
}
